import { TDeviceType } from '@cian/ui-kit';

/** Имя UXFB-события захода в карточку застройщика. Должно побайтово совпадать с кампаниями в админке UXFB. */
export const UXFB_EVENT_OPEN_DEVELOPER_CARD = 'open_developer_card';

/**
 * Платформа UXFB-события по типу устройства: страница респонсивная, поэтому платформа не фиксированная.
 * Значения — по общему контракту UXFB-событий веба: десктопная версия шлёт `desktop`,
 * мобильная (телефоны и планшеты) — `mobweb`.
 */
export const UXFB_PLATFORM_BY_DEVICE_TYPE: Record<TDeviceType, string> = {
  desktop: 'desktop',
  tablet: 'mobweb',
  phone: 'mobweb',
};

/**
 * Kill-switch клиентских UXFB-событий. По умолчанию события включены; выключаются значением `false`
 * в конфиге (`uxfeedback.clientEvents.enabled`).
 */
export const UXFB_CLIENT_EVENTS_CONFIG_KEY = 'uxfeedback.clientEvents.enabled';
